/** Regenerate rather than editing by hand: `WRITE_SHIP_UPGRADES=1 dotnet test tests/WarInSpace.Simulation.Tests` (pinned to `tests/vectors/ship-upgrades.json`). */
export interface UpgradeLabel {
  readonly name: string;
  readonly abbr: string;
}

export const UPGRADE_LABELS: ReadonlyMap<number, UpgradeLabel> = new Map([
  [0, { name: 'Hull Increase', abbr: 'Hull' }],
  [1, { name: 'Timed Shield', abbr: 'Shld' }],
  [2, { name: 'Movement Speed', abbr: 'Move' }],
  [3, { name: 'Passive Scrap', abbr: 'Scrp' }],
  [4, { name: 'Sniper Shot', abbr: 'Shot' }],
  [5, { name: 'Repair in Radius', abbr: 'Repi' }],
  [6, { name: 'Engine Overdrive', abbr: 'EngO' }],
  [7, { name: 'Weapon Damage', abbr: 'Dmg' }],
  [8, { name: 'Stealth', abbr: 'Stlh' }],
  [9, { name: 'Crit Chance', abbr: 'Crit' }],
  [10, { name: 'Scrap in Radius', abbr: 'Scrp' }],
  [11, { name: 'Absorbtion', abbr: 'Asrb' }],
  [12, { name: 'Self Repair Bots', abbr: 'Repr' }],
  [13, { name: 'Basic Turret', abbr: 'Turr' }],
  [14, { name: 'Basic Drones', abbr: 'Dron' }],
  [15, { name: 'Advanced Drones', abbr: 'AdvD' }],
  [16, { name: "Burst Heal'n'Speed", abbr: 'B&M' }],
  [17, { name: 'Increase Shot Range', abbr: 'Rang' }],
  [18, { name: 'Maximum Drones', abbr: 'Max' }],
  [19, { name: 'Area Damage Buff', abbr: 'ArDm' }],
  [20, { name: 'Healing Pod', abbr: 'Pod' }],
  [21, { name: 'Advanced Turret', abbr: 'AdvT' }],
  [22, { name: 'Long Range Turret', abbr: 'LngT' }],
  [23, { name: 'Sniper Drones', abbr: 'Snip' }],
  [24, { name: 'Damage In Radius', abbr: 'DmgR' }],
  [25, { name: 'Area Shield', abbr: 'AShi' }],
  [26, { name: 'Suicide Drones', abbr: 'Suic' }],
  [27, { name: 'Explosive Damage', abbr: 'Expl' }],
  [28, { name: 'Burst Heal', abbr: 'Heal' }],
]);

export const SHIP_UPGRADE_PATHS: readonly (readonly number[])[] = [
  [1, 2, 3],
  [28, 2, 5],
  [4, 9, 3],
  [1, 7, 0],
  [16, 5, 2],
  [13, 3, 2],
  [4, 3, 17],
  [14, 3, 18],
  [1, 7, 0],
  [19, 0, 12],
  [16, 5, 2],
  [20, 5, 2],
  [21, 3, 2],
  [22, 3, 2],
  [8, 9, 2],
  [23, 17, 2],
  [15, 3, 18],
  [26, 3, 27],
  [1, 7, 0],
  [19, 24, 0],
  [19, 0, 12],
  [25, 0, 12],
];

export const PLAYER_TARGETED_UPGRADES: ReadonlyMap<number, number> = new Map([[4, 0]]);

export function upgradeLabel(upgradeId: number): UpgradeLabel {
  return UPGRADE_LABELS.get(upgradeId) ?? { name: `Upgrade ${String(upgradeId)}`, abbr: '???' };
}

export function upgradeForPath(shipId: number, path: number): number {
  return SHIP_UPGRADE_PATHS[shipId]?.[path] ?? -1;
}

export function resolvedUpgradeForSlot(
  shipId: number,
  slot: number,
  resolvedIds: readonly number[] | null,
): number {
  return resolvedIds?.[slot] ?? upgradeForPath(shipId, slot);
}
